module.exports = __webpack_public_path__ + "img/cierrecaja-icon.84668974.png";